import theme from "@/theme";
import { FC, SVGProps } from "react";

interface LogoutSvgProps extends SVGProps<SVGSVGElement> {
  size?: number;
  strokeColor?: string;
}

const LogoutSvg: FC<LogoutSvgProps> = ({
  size = 20,
  strokeColor = `${theme.palette.custom.mainBlue}`,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.3339 6.6648V4.99744C13.3339 4.07622 12.5878 3.33008 11.6666 3.33008H4.16345C3.24224 3.33008 2.49609 4.07622 2.49609 4.99744V15.0016C2.49609 15.9228 3.24224 16.669 4.16345 16.669H11.6666C12.5878 16.669 13.3339 15.9228 13.3339 15.0016V13.3342"
      stroke={strokeColor}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3365 9.99887H9.16602"
      stroke={strokeColor}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8359 7.5L18.337 10.0002L15.8359 12.5012"
      stroke={strokeColor}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LogoutSvg;
